import {Box, Tabs, styled} from '@mui/material';

export const StyledBoxTitle = styled(Box)`
	display: flex;
	flex-direction: column;
	gap: 16px;
	margin-bottom: 10px;
	align-items: flex-start;
`;

export const StyledTabs = styled(Tabs)(({theme}) => ({
	minHeight: 48,
	borderBottom: `1px solid ${theme.palette.divider}`,
	'& .MuiTab-root': {
		minHeight: 48,
		textTransform: 'none',
	},
}));
